import React from 'react';
import { motion } from 'framer-motion';
import { KeyRound, Shield, Zap } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import SpotlightCard from '../ui/SpotlightCard';
import SpotlightButton from '../ui/SpotlightButton';
import AnimatedBadge from '../ui/AnimatedBadge';

export default function CertificateSection() {
  const { openModal } = useContact();
  return (
    <section id="certificado" className="w-full bg-background py-32 overflow-hidden border-y border-foreground/5 relative">
      {/* Orange Identity Glows */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-orange-600/10 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-orange-500/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-20">
          
          <div className="w-full md:w-1/2 text-center md:text-left">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="mb-4 md:mb-6 flex justify-center md:justify-start">
                <AnimatedBadge>
                  Orange Identity
                </AnimatedBadge>
              </div>
              <h2 className="text-2xl md:text-5xl font-black text-foreground tracking-tight mb-6 md:mb-8 leading-tight">
                Certificação Digital <br className="hidden md:block" /> de Alta Segurança
              </h2>
              <p className="text-sm md:text-lg text-slate-400 mb-8 md:mb-10 font-medium leading-relaxed max-w-lg mx-auto md:mx-0">
                Sua identidade digital com o padrão JWCosta. Agilidade na emissão e segurança absoluta.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 md:mb-10">
                <SpotlightCard innerClassName="p-6" radius="1.5rem">
                  <div className="flex items-center gap-4 text-left">
                    <div className="w-12 h-12 bg-orange-600/10 rounded-xl flex items-center justify-center shrink-0">
                      <KeyRound className="text-orange-500" size={24} />
                    </div>
                    <div>
                      <h4 className="text-foreground font-bold text-sm">Criptografia</h4>
                      <p className="text-slate-500 text-[10px] uppercase tracking-widest font-black">ICP-Brasil</p>
                    </div>
                  </div>
                </SpotlightCard>
                <SpotlightCard innerClassName="p-6" radius="1.5rem">
                  <div className="flex items-center gap-4 text-left">
                    <div className="w-12 h-12 bg-orange-600/10 rounded-xl flex items-center justify-center shrink-0">
                      <Shield className="text-orange-500" size={24} />
                    </div>
                    <div>
                      <h4 className="text-foreground font-bold text-sm">Validade</h4>
                      <p className="text-slate-500 text-[10px] uppercase tracking-widest font-black">Jurídica Total</p>
                    </div>
                  </div>
                </SpotlightCard>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start px-6 sm:px-0">
                <a 
                  href="https://wa.me/5511949830659"
                  rel="noopener noreferrer"
                  className="w-full sm:w-[240px] px-10 py-4 bg-orange-600 hover:bg-orange-500 text-white font-black rounded-full transition-all duration-300 uppercase tracking-widest text-[10px] shadow-lg shadow-orange-600/20 text-center flex items-center justify-center whitespace-nowrap"
                >
                  Emitir Agora
                </a>
                <SpotlightButton href="https://wa.me/5511949830659" className="w-full sm:w-[240px]">
                  <div className="flex items-center gap-2">
                    <Zap size={16} className="text-orange-500" /> Renovação Expressa
                  </div>
                </SpotlightButton>
              </div>
            </motion.div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center">
            {/* Premium Card with Orange Identity */}
            <div className="relative w-64 md:w-80 h-[380px] md:h-[450px] bg-gradient-to-br from-orange-600 to-orange-400 rounded-[2.5rem] p-8 md:p-10 shadow-2xl transform md:rotate-3 hover:rotate-0 transition-all duration-700 border border-foreground/20 flex flex-col items-center justify-center text-center group">
              <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff10_1px,transparent_1px),linear-gradient(to_bottom,#ffffff10_1px,transparent_1px)] bg-[size:24px_24px] rounded-[2.5rem]"></div>
              
              <div className="relative w-28 h-28 bg-white/10 backdrop-blur-xl rounded-[2rem] flex items-center justify-center shadow-xl border border-foreground/20 mb-10 group-hover:scale-110 transition-transform duration-500">
                <KeyRound size={56} className="text-white drop-shadow-lg" />
              </div>
              
              <h3 className="text-4xl font-black text-white mb-2 tracking-tighter">
                A1 / A3
              </h3>
              <p className="text-orange-950/60 text-xs font-black tracking-widest uppercase mb-8">
                Criptografia Ativa
              </p>
              
              <div className="w-full py-4 bg-white/10 rounded-2xl border border-foreground/20 flex items-center justify-center gap-3 text-white font-bold backdrop-blur-md">
                <Shield size={18} className="text-orange-900" /> VALIDADO
              </div>
              
              {/* Internal Glow */}
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/20 rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
